import React from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Typography,
  makeStyles,
  useTheme,
  useMediaQuery,
  IconButton,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import DrawerComponent from "./Drawer";
import Logo from "../images/Logo.png";



const useStyles = makeStyles((theme) => ({
  navlinks: {
    marginLeft: theme.spacing(5),
    display: "flex",
  },
  logo: {
    flexGrow: "1",
    cursor: "pointer",
    fontFamily: "cursive",
  },
  link: {
    textDecoration: "none",
    fontFamily: "cursive",
    color: "white",
    fontSize: "20px",
    marginLeft: theme.spacing(15),
    "&:hover": {
      color: "yellow",
      borderBottom: "1px solid white",
      
    },
    
  },

  abRoot: {
    backgroundColor: "seaGreen",
    opacity: 0.7
  },
  abStatic: {
    border: "solid blue 2px"
  },
}));

function Navbar() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppBar position="sticky" classes={{ 
      root: classes.abRoot, 
      positionStatic: classes.abStatic 
    }} >
      <CssBaseline />
      <Toolbar>
      
        <Typography variant="h4" className={classes.logo}>
          
          <img src={Logo} alt="logo" width={"80px"}/>
          PORTFOLIO
        </Typography>
        {isMobile ? (
          <DrawerComponent />
        ) : (
          <div className={classes.navlinks}>
            <Link to="/aboutme" className={classes.link}>
              ABOUT
            </Link>
            <Link to="/" className={classes.link}>
              HOME
            </Link>
            <Link to="/projects" className={classes.link}>
              PROJECTS
            </Link>
            <Link to="/resume" className={classes.link}>
              RESUME
            </Link>
            <Link to="/certifications" className={classes.link}>
              CERTIFICATIONS
            </Link>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
}
export default Navbar;